import { Injectable } from "@angular/core"
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router"

@Injectable()
export class SubjectsGuard {
    constructor(private router: Router) {}
    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const selectedGrade = localStorage.getItem("grade-gate")
        if (route.queryParams.student && selectedGrade && !route.queryParams.selected_facet) {
            this.router.navigate(["/subjects/" + route.params.nodeSlug], {
                queryParams: {
                    selected_facet: "grades:" + selectedGrade,
                    student: true,
                },
            })
            return false
        }
        return true
    }
}
